import React from "react";
import "tailwindcss/tailwind.css";

export const PrimaryButton = ({ onClick, children, className = "", type = 'button' }) => {
  return (
    <button
      type={type}
      className={`text-white bg-primary py-2 px-4 rounded hover:bg-primary-dark w-full ${className}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

const Spinner = () => (
  <svg
    className="animate-spin h-4 w-4 text-current"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
    />
  </svg>
);

export const PrimaryButtonSmall = ({ onClick, children, loading, loadingLabel, className = "", type = 'button', disabled = false }) => {
  return (
    <button
      type={type}
      disabled={loading || disabled}
      aria-busy={loading || undefined}
      className={`text-white bg-primary py-2 px-4 rounded hover:bg-primary-dark disabled:opacity-70 ${loading ? 'disabled:cursor-wait' : 'disabled:cursor-not-allowed'} inline-flex items-center justify-center gap-2 ${className}`}
      onClick={onClick}
    >
      {loading && <Spinner />}
      {loading && loadingLabel ? <span>{loadingLabel}</span> : children}
    </button>
  );
};

export const SecondaryDangerButtonSmall = ({ onClick, children, loading, className = "", type = 'button' }) => {
  return (
    <button
      type={type}
      disabled={loading}
      className={`bg-red-500 text-yellow-50 border border-red-500 py-2 px-4 rounded disabled:opacity-50 ${className}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};
export const SecondaryButtonSmall = ({ onClick, children, loading, className = "", type = 'button', disabled = false }) => {
  return (
    <button
      type={type}
      // `disabled` was accepted by callers long before it was honoured here, so
      // a button meant to be held during a save (a queue write, a text going
      // out) stayed clickable and could fire twice.
      disabled={loading || disabled}
      className={`bg-white dark:bg-gray-800 text-primary border border-primary py-2 px-4 rounded ${loading ? 'animate-pulse' : 'disabled:opacity-50'} ${className}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export const SecondaryButton = ({ onClick, children, className = "", type = 'button' }) => {
  return (
    <button
      type={type}
      className={`bg-white dark:bg-gray-800 text-primary border border-primary py-2 px-4 rounded ${className}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export const LinkButton = ({ onClick, children, className = "", type = 'button' }) => {
  return (
    <button
      type={type}
      className={`text-primary focus:no-underline hover:no-underline ${className}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};
